import React from 'react';

function ToggleSwitch({ label, checked, disabled = false, onChange, enabledText = 'Enabled', disabledText = 'Disabled' }) {
    return (
        <label className="cc-switch">
            <input
                type="checkbox"
                role="switch"
                className="cc-switch__input"
                aria-label={label}
                checked={checked}
                disabled={disabled}
                onChange={(event) => onChange?.(event.target.checked)}
            />
            <span className="cc-switch__track" aria-hidden="true">
                <span className="cc-switch__knob" />
            </span>
            <span className="cc-switch__status">{checked ? enabledText : disabledText}</span>
        </label>
    );
}

export default ToggleSwitch;
